import { EnumScreenNames } from "../enums/EnumScreenNames";

export default {
  staticPages: {
    screenName: "staticPageScreen",
  },
  [`allSearchFilterScreen`]:{
    screenName:`allSearchFilterScreen`
  },
  [`AutosSearchFilterScreen`]:{
    screenName:`AutosSearchFilterScreen`
  },
  [`ElectronicsSearchFilterScreen`]:{
    screenName:`ElectronicsSearchFilterScreen`
  },
  [`RealEstateForSaleSearchFilterScreen`]:{
    screenName:`RealEstateForSaleSearchFilterScreen`
  },
  [`RealEstateForRentSearchFilterScreen`]:{
    screenName:`RealEstateForRentSearchFilterScreen`
  },
  [`JobsVerticalSearchFilterScreen`]:{
    screenName:`JobsVerticalSearchFilterScreen`
  },
  [`MotorcyclesSearchFilterScreen`]:{
    screenName:`MotorcyclesSearchFilterScreen`
  },
  [`MobileTabletSearchFilterScreen`]:{
    screenName:`MobileTabletSearchFilterScreen`
  },
  [`GamingSearchFilterScreen`]:{
    screenName:`GamingSearchFilterScreen`
  },
  [`HomeAndFurnitureSearchFilterScreen`]:{
    screenName:`HomeAndFurnitureSearchFilterScreen`
  },
  [`ClothingAndAccessoriesSearchFilterScreen`]:{
    screenName:`ClothingAndAccessoriesSearchFilterScreen`
  },
  [`MenFashionSearchFilterScreen`]:{
    screenName:`MenFashionSearchFilterScreen`
  },
  [`BabyKidsSearchFilterScreen`]:{
    screenName:`BabyKidsSearchFilterScreen`
  },
  [`FoodSearchFilterScreen`]:{
    screenName:`FoodSearchFilterScreen`
  },
  [`EducationAndTrainingSearchFilterScreen`]:{
    screenName:`EducationAndTrainingSearchFilterScreen`
  },
  [`ServicesSearchFilterScreen`]:{
    screenName:`ServicesSearchFilterScreen`
  },
  [`AnimalsSearchFilterScreen`]:{
    screenName:`AnimalsSearchFilterScreen`
  },
  [`BooksHobbiesFilterScreen`]:{
    screenName:`BooksHobbiesFilterScreen`
  },
  [`SportsSearchFilterScreen`]:{
    screenName:`SportsSearchFilterScreen`
  },
  "BusinessIndustrialSearchFilterScreen":{
    screenName:`BusinessIndustrialSearchFilterScreen`
  },
  "ComputerAndLaptopsSearchFilterScreen":{
    screenName:`ComputerAndLaptopsSearchFilterScreen`
  },
  [EnumScreenNames.HOME_PAGE]: {
    screenName: "HomeScreen",
  },
  [EnumScreenNames.ADD_FREE_POST]: {
    screenName: "AddFreePostScreen",
  },
  [EnumScreenNames.LANDING_PAGE]: {
    screenName: "ChooseSubCategoryScreen",
  },
  [EnumScreenNames.SHOP_LISTINGS_SCREEN]: {
    screenName: "ShopListingsScreen",
  },
  [EnumScreenNames.SHOP_RATING_SCREEN]: {
    screenName: "Member/Shop/Rating",
  },
  [EnumScreenNames.SHOPS_SCREEN]: {
    screenName: "ShopsScreen",
  },
  [EnumScreenNames.POST_VIEW_SCREEN]: {
    screenName: "PostViewScreen",
  },
  [EnumScreenNames.POST_GALLERY_SCREEN]: {
    screenName: "PostGalleryScreen",
  },
  [EnumScreenNames.POST_GALLERY_EXPAND_VIEW]: {
    screenName: "ExpandView_PostGalleryScreen",
  },
  [EnumScreenNames.POST_GALLERY_NEXT_IMAGE]: {
    screenName: "NextPostImage",
  },
  [EnumScreenNames.POST_GALLERY_PREVIOUS_IMAGE]: {
    screenName: "PreviousPostImage",
  },
  [EnumScreenNames.MID_SCREEN]: {
    screenName: "Member",
  },
  [EnumScreenNames.MID_SCREEN_RATING]: {
    screenName: "Member/Rating",
  },
  [EnumScreenNames.WEATHER_SCREEN]: {
    screenName: "WeatherPageScreen",
  },
  [EnumScreenNames.PRAYER_TIME_SCREEN]: {
    screenName: "PrayerTimesPageScreen",
  },
  [EnumScreenNames.SAFETY_TIPS_SCREEN]: {
    screenName: "SafetyTipsScreen",
  },
  [EnumScreenNames.ADD_PICTURES_TIPS_SCREEN]: {
    screenName: "AddPicturesTipsScreen",
  },
  [EnumScreenNames.SALES_REPRESENTATIVES]: {
    screenName: "salesContactsScreen",
  },
  [EnumScreenNames.ADVERTISING_PRODUCTS]: {
    screenName: "VasPageScreen",
  },
  [EnumScreenNames.POST_VIEW_SCREEN]: {
    screenName: "PostViewScreen",
  },
  [EnumScreenNames.OPENSOOQ_LOGO_SCREEN]: {
    screenName: "OpenSooqLogoPageScreen",
  },
  [EnumScreenNames.CAR_PRICES_SCREEN]: {
    screenName: "CarsSpecsLanding",
  },
  [EnumScreenNames.AUTOS_SERVICE_SCREEN]: {
    screenName: "AutoServiceLanding",
  },
  selectCountryScreen: {
    screenName: "SelectCountryScreen",
  },
  [EnumScreenNames.SUPPORT_INDEX_SCREEN]: {
    screenName: "HelpCenterScreen",
  },
  [EnumScreenNames.CONTACT_US_SCREEN]: {
    screenName: "ContactUsScreen",
  },
  contactUsFormScreen: {
    screenName: "ContactUsFormScreen",
  },
  thanks4uFeedbackScreen: {
    screenName: "SuccessCustomerSupportScreen",
  },
  [EnumScreenNames.SUPPORT_FAQ_SCREEN]: {
    screenName: "FAQ_Articles_Screen",
  },
  [EnumScreenNames.SERP_SCREEN]: {
    screenName: "SearchScreen",
  },
  [EnumScreenNames.SIMILAR_SCREEN]: {
    screenName: "SimilarScreen",
  },
  [EnumScreenNames.RECOMMENDED_SCREEN]: {
    screenName: "RecommendedScreen",
  },
  [EnumScreenNames.TAGS_DETAILS]: {
    screenName: "SearchScreen",
  },
  [EnumScreenNames.CAR_REPORTS_SCREEN]: {
    screenName: "car-reports-screen",
  },
  [EnumScreenNames.CarReportsLanding]: {
    screenName: "CarReportsLanding",
  },
  midFollowersScreen: {
    screenName: "MIDFollowersScreen",
  },
  advertisingProductsPremium: {
    screenName: "advertising-products-Premium-package",
  },
  advertisingProductsVip: {
    screenName: "advertising-products-Vip-package",
  },
  advertisingProductsBumpup: {
    screenName: "advertising-products-Bumpup-package",
  },
  advertisingProductsTurbo: {
    screenName: "TurboAdPageScreen",
  },
  advertisingProductsElas: {
    screenName: "ElasPageScreen",
  },
  advertisingProductsWallet: {
    screenName: "WalletLandingPage",
  },
  boostAdPackagesPage: {
    screenName: "BoostAdSelectPackageScreen",
  },
  downloadAppScreen: {
    screenName: "DownloadAppScreen",
  },
  slrMainScreen: {
    screenName: "SLRMainScreen",
  },
  slrSuccessScreen: {
    screenName: "SLRSuccessScreen",
  },
  slrLoginScreen: {
    screenName: "SLRLoginScreen",
  },
  slrCompleteInfoScreen: {
    screenName: "SLRCompleteInfoScreen",
  },
  slrLoginOTPScreen: {
    screenName: "SLRLoginOTPScreen",
  },
  slrCompleteLoginOTPScreen: {
    screenName: "SLRCompleteLoginOTPScreen",
  },
  slrAddEditPhoneScreen: {
    screenName: "SLRAddEditPhone",
  },
  slrResetPassScreen: {
    screenName: "SLRResetPassScreen",
  },
  slrSMSPendingScreen: {
    screenName: "SLRSMSPendingScreen",
  },
  slrResetScreen: {
    screenName: "SLRResetScreen",
  },
  [EnumScreenNames.SHOPS_LIST_SCREEN]: {
    screenName: "ShopsListScreen",
  },
  slrErrorScreen: {
    screenName: "SLRErrorScreen",
  },
  slrRegistrationScreen: {
    screenName: "SLRRegistrationScreen",
  },
  slrVIBPendingScreen: {
    screenName: "SLRVIBPendingScreen",
  },
  editProfileScreen: {
    screenName: "EditProfileScreen",
  },
  nextPageScreen: {
    screenName: "LoadMore_SearchScreen",
  },
  Screen: {
    screenName: "LoadMore_SearchScreen",
  },
  [EnumScreenNames.ABOUT_US_SCREEN]: {
    screenName: "aboutUsScreen",
  },
  [EnumScreenNames.SEARCH_FOR_USER_NAME]: {
    screenName: "SearchForUserName",
  },
  [EnumScreenNames.SELLER_PAGES_SCREEN]: {
    screenName: "SellerPagesScreen",
  },
  [EnumScreenNames.SELL_ANY_THING_SCREEN]: {
    screenName: "SellAnyThingScreen",
  },
  [EnumScreenNames.MOTORS_SELL_IT_FOR_ME_SCREEN]: {
    screenName: "MotorsSellItForMeScreen",
  },
  [EnumScreenNames.MOTORS_SELL_MY_CAR_SCREEN]: {
    screenName: "MotorsSellMyCarScreen",
  },
  [EnumScreenNames.PROPERTY_SELL_MY_PROPERTY_SCREEN]: {
    screenName: "PropertySellMyPropertyScreen",
  },
  [EnumScreenNames.PROPERTY_SELL_IT_FOR_ME_SCREEN]: {
    screenName: "PropertySellItForMeScreen",
  },
  [EnumScreenNames.PROPERTY_RENT_MY_PROPERTY_SCREEN]: {
    screenName: "PropertyRentMyPropertyScreen",
  },
  [EnumScreenNames.PROPERTY_RENT_IT_FOR_ME_SCREEN]: {
    screenName: "PropertyRentItForMeScreen",
  },
  [EnumScreenNames.FIND_A_JOB_SCREEN]: {
    screenName: "FindAJobScreen",
  },
  [EnumScreenNames.HIRE_PEOPLE_SCREEN]: {
    screenName: "HirePeopleScreen",
  },
};
